<template>
  <CustomContainer
    :showAddButton="false"
    padding="p-4"
  >
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-3">
        <ThemeImage
          :icon="icon"
          :alt="iconAlt"
          class="size-4"
        />
        <div class="flex flex-col">
          <span class="text-sm font-semibold">{{ title }}</span>
          <span class="text-xs secondary_color">{{ subtitle }} · {{ formattedDate }}</span>
        </div>
      </div>
      <div class="flex items-center gap-2">
        <a-tooltip title="Edit action">
          <ThemeImage
            :icon="imageNames.EDIT_SQUARE"
            alt="edit_icon"
            class="size-4 cursor-pointer"
            @click="$emit('edit')"
          />
        </a-tooltip>
        <ThemeImage
          :icon="imageNames.DELETE_GREY"
          alt="delete_icon"
          class="size-4 cursor-pointer"
          @click="$emit('delete')"
        />
      </div>
    </div>
  </CustomContainer>
</template>

<script setup>
import { computed } from "vue";
import ThemeImage from "@/src/components/ThemeImage.vue";
import CustomContainer from "@/src/components/CustomContainer.vue";
import { imageNames } from "@/src/constants/imageConstants.js";
import {formatTimestamp} from "@/src/utils/dateTimeUtils.js";
import { formatTypes } from "@/src/constants/dateTimeConstants.js";

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  iconAlt: {
    type: String,
    default: "item_icon",
  },
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    required: true,
  },
  date: {
    type: String,
    required: true,
  },
});

defineEmits(["edit", "delete"]);

const formattedDate = computed(() => {
  return formatTimestamp(props.date, "timestamp", formatTypes.dateOnly);
});
</script>

